import { useEffect } from "react";
import { clearStoredContentFilters } from "../domains/app/utils/contentFilters";

export function useStorageCleanup() {
  useEffect(() => {
    clearStoredContentFilters();
  }, []);
}
